import { render } from "./IconCheckCircle.vue?vue&type=template&id=e4140ca4&ts=true"
import script from "./IconCheckCircle.vue?vue&type=script&lang=ts"
export * from "./IconCheckCircle.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/paulbele/Code/repositories/maatoo-app-master/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__